import { SettlementType } from 'app/constants/settlementType'

export const getSettlementType = (type) => {
  let settlementType = SettlementType.NotSet

  switch (type) {
    case 1:
      settlementType = SettlementType.Month
      break
    case 2:
      settlementType = SettlementType.Hour
      break
    case 3:
      settlementType = SettlementType.ForContract
      break
  }

  return settlementType
}

export const getSettlementTypeRawApiFormat = (type: SettlementType) => {
  switch (type) {
    case SettlementType.Month:
      return 1
    case SettlementType.Hour:
      return 2
    case SettlementType.ForContract:
      return 3
    default:
      return 0;
  }
}
